// extracted by mini-css-extract-plugin
module.exports =  {"promotion":"nGEatR7","banner-message":"qhsozXP","bannerMessage":"qhsozXP","icon":"BSgX7Xi"};